import React from 'react';
import { FaLayerGroup, FaChevronRight, FaTimes } from 'react-icons/fa';

const LEGEND_CLASSES = [
  ['#CCFFFF', '< 0.2 m'],
  ['#FFFFCC', '0.2 – 1 m'],
  ['#FFCC00', '1 – 3 m'],
  ['#FF8C00', '3 – 5 m'],
  ['#FF2200', '5 – 10 m'],
  ['#8B0000', '> 10 m'],
];

// variant "corner" (desktop/tablet): floating top-right panel with its own
// collapse icon-button, matching the other floating panels.
// variant "popover" (mobile): no icon button of its own — MobileActionBar
// drives open/close, this just renders the panel content above the bar.
export default function LayerControl({ visibility, onToggle, hasScenario, variant = 'corner', open, onOpenChange }) {
  const legendBody = (
    <>
      <label className="layer-toggle">
        <input
          type="checkbox"
          checked={visibility.waveheight}
          onChange={() => onToggle('waveheight')}
        />
        Wave Height
      </label>

      {hasScenario && visibility.waveheight && (
        <div className="wh-legend">
          {LEGEND_CLASSES.map(([color, label]) => (
            <div className="legend-row" key={label}>
              <span className="legend-swatch" style={{ background: color }} />
              <span className="legend-label">{label}</span>
            </div>
          ))}
        </div>
      )}

      <label className="layer-toggle">
        <input
          type="checkbox"
          checked={visibility.contour}
          onChange={() => onToggle('contour')}
        />
        Arrival Time
      </label>

      {hasScenario && visibility.contour && (
        <div className="layer-key" style={{ margin: '0 0 4px 0' }}>
          <span className="lk-line" /> <span className="lk-txt">Major contours</span><br />
          <span className="lk-line-minor" /> <span className="lk-txt">Minor contours</span>
        </div>
      )}
    </>
  );

  if (variant === 'popover') {
    if (!open) return null;
    return (
      <div className="panel layer-panel layer-panel--popover">
        <div className="panel-header">
          <span className="panel-label">
            <FaLayerGroup size={9} style={{ marginRight: 5, verticalAlign: 'middle' }} />
            Layers
          </span>
          <button className="panel-collapse-btn" onClick={() => onOpenChange(false)} title="Close">
            <FaTimes size={11} />
          </button>
        </div>
        {legendBody}
      </div>
    );
  }

  if (!open) {
    return (
      <div
        className="panel-icon-btn layer-icon-btn"
        onClick={() => onOpenChange(true)}
        title="Layers"
      >
        <FaLayerGroup size={16} color="#555" />
      </div>
    );
  }

  return (
    <div className="panel layer-panel">
      <div className="panel-header">
        <button
          className="panel-collapse-btn"
          onClick={() => onOpenChange(false)}
          title="Collapse"
          style={{ paddingLeft: 0, paddingRight: 6 }}
        >
          <FaChevronRight size={9} />
        </button>
        <span className="panel-label">
          <FaLayerGroup size={9} style={{ marginRight: 5, verticalAlign: 'middle' }} />
          Layers
        </span>
      </div>
      {legendBody}
    </div>
  );
}
